//sku should cost workbench api services
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'
import { skuShouldCostWorkbenchApiRoutes } from 'src/constants/serviceConstants/costModelling.apiRoutes'

//get sku kpis
export const getSkuKPIsAsync = createAsyncThunk(
  'api/should-cost-workbench/get-sku-kpis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSkuKpis, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get skus based on search
export const getSkuListAsync = createAsyncThunk(
  'api/should-cost-workbench/get-skus-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getSkuList, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get sku count
export const getTotalSkuCountAsync = createAsyncThunk(
  'api/should-cost-workbench/get-sku-total-pages',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.getTotalSkuCount, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// set final should cost model
export const setFinalShouldCostModel = createAsyncThunk(
  'api/should-cost-workbench/set-final-should-cost-model',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.setFinalModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

// get Should Cost Breakdown
export const getShouldCostBreakdownDataAsync = createAsyncThunk(
  'api/should-cost-workbench/get-should-cost-breakdown-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getShouldCostBreakdownForModel,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get should cost models by sku
export const getShouldCostModelsBySkuAsync = createAsyncThunk(
  'api/should-cost-workbench/get-should-cost-models-by-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getShouldCostModelsBySku,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//check for mini ifa calculation
export const checkIfaProgressAsync = createAsyncThunk(
  'api/should-cost-workbench/check-Ifa-progress',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.checkIfaProgress, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//download should Cost
export const downloadShouldCostAsync = createAsyncThunk(
  'api/should-cost-workbench/download-should-cost',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.downloadShouldCost, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get all vendors of sku
export const getAllVendorsOfSkuAsync = createAsyncThunk(
  'api/should-cost-workbench/get-all-vendors-of-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes?.getAllVendorsForSku,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

//get files attached to Model
export const attachedModelFilesAsync = createAsyncThunk(
  'api/should-cost-workbench/attachedModelFilesData',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.attachFilesToModel, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//get currency exchange rate
export const getCurrencyExchangeRateAsync = createAsyncThunk(
  'api/should-cost-workbench/get-currency-exchange-rate',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes.getCurrencyExchangeRate,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getMaxDateAsync = createAsyncThunk(
  'api/should-cost-workbench//get-max-date',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', skuShouldCostWorkbenchApiRoutes?.getMaxDate, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//delete sku should cost mapping

export const deleteSKUMappingAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/delete-sku-should-cost-mapping',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      skuShouldCostWorkbenchApiRoutes.deleteSkuShouldCostMapping,
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const attachModelsToSkuAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/attach-models-to-sku',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes.attachModelsToSku, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

//upload sku master file
export const validateFileUploadsync = createAsyncThunk(
  'api/sku-should-cost-workbench/upload-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.validateFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

// download sku master and po standard template
export const downloadFileTemplateAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/download-file-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.downloadFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

//finish upload sku master file
export const fileUploadAsync = createAsyncThunk(
  'api/sku-should-cost-workbench/finish-upload-template',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', skuShouldCostWorkbenchApiRoutes?.uploadFile, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
